// eslint-disable-next-line import/prefer-default-export
export const GET_DISTRIBUTION_DATA = 'freebsw/GET_DISTRIBUTION_DATA'
export const GET_DISTRIBUTION_TABLE = 'freebsw/GET_DISTRIBUTION_TABLE'
export const SEND_HARVEST_DATA = 'freebsw/SEND_HARVEST_DATA'
export const ERROR = 'ERROR'
export const CLEAR_ERROR = 'CLEAR_ERROR'
